import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import { PROVINCE, useSession, CircleSpinner } from '@ratehub/base-ui';
import { CCSideBySide as SideBySide } from '@ratehub/cc-common';

import PAGE_TEMPLATES from '../definitions/PageTemplates';


function CCSideBySide({
    initialProvinceCode = PROVINCE.ONTARIO,
    isPreview = false,
}) {
    const { interestLocation, hasFetchedSession } = useSession();
    const [ province, setProvince ] = useState(initialProvinceCode);

    // fetch the cards when the component mounts with auto-detected user location
    useEffect(() => {
        if (hasFetchedSession && initialProvinceCode === PROVINCE_AUTOMATIC) {
            setProvince(interestLocation?.province || DEFAULT_PROVINCE);
        }
    }, [ hasFetchedSession ]);

    return (
        <Container className="rh-position-relative">
            <Choose>
                <When condition={hasFetchedSession || isPreview}>
                    <SideBySide
                        province={province}
                    />
                </When>
                <Otherwise>
                    <CircleSpinner />
                </Otherwise>
            </Choose>
        </Container>
    );
}

const PROVINCE_AUTOMATIC = 'automatic';
const DEFAULT_PROVINCE = PROVINCE.ONTARIO;

CCSideBySide.propTypes = {
    initialProvinceCode: PropTypes.string,
    isPreview: PropTypes.bool, // required by CMS editor view because they lack profiles session
};

CCSideBySide.blockKey = 'rh/cc-side-by-side';
CCSideBySide.requiresLayoutRow = true;
CCSideBySide.supportedPageTypes = [ PAGE_TEMPLATES.creditCards ];

const Container = styled.section`
    min-height: 50vh;
    min-width: 100%;
`;


export default observer(CCSideBySide);
